var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 94c25.957 0 47-21.043 47-47S80.957 0 55 0 8 21.043 8 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.581 7.4H97.067C84.6 7.4 73.914 14.8 69.62 25.3l7.962 15.9h7.648c6.81 0 12.361-5.3 12.361-11.8l-.209-.5c4.295-1.9 7.333-6 7.333-10.8 0 0 5.867-4.2 5.867-10.7Z",
    fill: "#8DD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.01 29.4c0 6.5-5.553 11.8-12.362 11.8H78m-8.067-15.9c4.4-10.5 14.981-17.9 27.553-17.9H111c0 6.5-5.552 11.8-12.362 11.8h-5.343l-23.362 6.1Zm35.2-7.2c0 6.5-5.552 11.8-12.362 11.8h-5.34l17.702-11.8Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.619 7.4H1c0 6.5 5.867 10.7 5.867 10.7 0 4.8 3.038 8.9 7.333 10.8l-.21.5c0 6.5 5.553 11.8 12.362 11.8H34l7.962-15.9C37.772 14.8 27.086 7.4 14.619 7.4Z",
    fill: "#8DD9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 29.4c0 6.5 5.552 11.8 12.36 11.8h7.649m8.067-15.9C38.19 14.8 27.505 7.4 15.038 7.4H1.42c0 6.5 5.552 11.8 12.362 11.8h5.343l23.36 6.1Zm-35.2-7.2c0 6.5 5.552 11.8 12.362 11.8h5.342L7.286 18.1Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.9 61.1-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    fill: "#FF6F6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m37.9 61.1-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m72.7 61.1 7.1 19.4c.5 1.4-1 2.7-2.3 2.1l-4.3-2.1c-.9-.4-1.9 0-2.3.8L69 85.7c-.6 1.4-2.6 1.3-3.1-.1l-7.1-19.4",
    fill: "#FF6F6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m72.7 61.1 7.1 19.4c.5 1.4-1 2.7-2.3 2.1l-4.3-2.1c-.9-.4-1.9 0-2.3.8L69 85.7c-.6 1.4-2.6 1.3-3.1-.1l-7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m86.7 37.7 1.5-2.6c1.4-2.4.6-5.5-1.9-6.9l-2.6-1.5c-1.6-.9-2.5-2.6-2.5-4.4v-3c0-2.8-2.3-5.1-5.1-5.1h-3c-1.8 0-3.5-1-4.4-2.5l-1.5-2.6c-1.4-2.4-4.5-3.3-6.9-1.9l-2.6 1.5c-1.6.9-3.5.9-5.1 0L50 7.2c-2.4-1.4-5.5-.6-6.9 1.9l-1.5 2.6c-.9 1.6-2.6 2.5-4.4 2.5h-3c-2.8 0-5.1 2.3-5.1 5.1v3c0 1.8-1 3.5-2.5 4.4L24 28.2c-2.4 1.4-3.3 4.5-1.9 6.9l1.5 2.6c.9 1.6.9 3.5 0 5.1l-1.5 2.6c-1.4 2.4-.6 5.5 1.9 6.9l2.6 1.5c1.6.9 2.5 2.6 2.5 4.4v3c0 2.8 2.3 5.1 5.1 5.1h3c1.8 0 3.5 1 4.4 2.5l1.5 2.6c1.4 2.4 4.5 3.3 6.9 1.9l2.6-1.5c1.6-.9 3.5-.9 5.1 0l2.6 1.5c2.4 1.4 5.5.6 6.9-1.9l1.5-2.6c.9-1.6 2.6-2.5 4.4-2.5h3c2.8 0 5.1-2.3 5.1-5.1v-3c0-1.8 1-3.5 2.5-4.4l2.6-1.5c2.4-1.4 3.3-4.5 1.9-6.9l-1.5-2.6c-.9-1.6-.9-3.5 0-5.1Z",
    fill: "#FF6F6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.7 37.7 1.5-2.6c1.4-2.4.6-5.5-1.9-6.9l-2.6-1.5c-1.6-.9-2.5-2.6-2.5-4.4v-3c0-2.8-2.3-5.1-5.1-5.1h-3c-1.8 0-3.5-1-4.4-2.5l-1.5-2.6c-1.4-2.4-4.5-3.3-6.9-1.9l-2.6 1.5c-1.6.9-3.5.9-5.1 0L50 7.2c-2.4-1.4-5.5-.6-6.9 1.9l-1.5 2.6c-.9 1.6-2.6 2.5-4.4 2.5h-3c-2.8 0-5.1 2.3-5.1 5.1v3c0 1.8-1 3.5-2.5 4.4L24 28.2c-2.4 1.4-3.3 4.5-1.9 6.9l1.5 2.6c.9 1.6.9 3.5 0 5.1l-1.5 2.6c-1.4 2.4-.6 5.5 1.9 6.9l2.6 1.5c1.6.9 2.5 2.6 2.5 4.4v3c0 2.8 2.3 5.1 5.1 5.1h3c1.8 0 3.5 1 4.4 2.5l1.5 2.6c1.4 2.4 4.5 3.3 6.9 1.9l2.6-1.5c1.6-.9 3.5-.9 5.1 0l2.6 1.5c2.4 1.4 5.5.6 6.9-1.9l1.5-2.6c.9-1.6 2.6-2.5 4.4-2.5h3c2.8 0 5.1-2.3 5.1-5.1v-3c0-1.8 1-3.5 2.5-4.4l2.6-1.5c2.4-1.4 3.3-4.5 1.9-6.9l-1.5-2.6c-.9-1.6-.9-3.5 0-5.1v0Z",
    stroke: "#E05F5F",
    strokeWidth: 3.43,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3 66.9c14.801 0 26.8-11.999 26.8-26.8S70.101 13.3 55.3 13.3 28.5 25.299 28.5 40.1s11.999 26.8 26.8 26.8Z",
    fill: "#E05F5F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m57 22.5 4.2 8.5c.3.5.8.9 1.4 1l9.3 1.4c1.5.2 2.1 2.1 1 3.1L66.1 43c-.4.4-.6 1-.5 1.6l1.6 9.3c.3 1.5-1.3 2.6-2.7 1.9l-8.4-4.4c-.5-.3-1.2-.3-1.7 0L46 55.8c-1.3.7-2.9-.4-2.7-1.9l1.6-9.3c.1-.6-.1-1.2-.5-1.6l-6.8-6.6c-1.1-1.1-.5-2.9 1-3.1l9.3-1.4c.6-.1 1.1-.5 1.4-1l4.2-8.5c.9-1.3 2.8-1.3 3.5.1Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.014
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel13);
export default __webpack_public_path__ + "static/media/level13.6f9018e9.svg";
export { ForwardRef as ReactComponent };